import logger from './debug-logger';
/**
 * Generate a function to handle a promise rejection. This logs to console.error when in
 * development or when on the server (so that developers see the error in browser console and
 * server side errors show up in sumo).
 *
 * Additionally, we try to use global.newrelic (which is present on the client side).
 *
 * @example
 * ```
 * someAsyncFunction()
 *  .then(() => console.log('Sweet Success!!!'))
 *  .catch(nrAwareRejectionHandler('Foiled again'));
 * // when executed on the server, or in development, this message will be logged to console.error.
 * // We always 'try' to use newrelic (from global.newrelic) regardless of the previous line.
 * ```
 *
 * @param {string} message - Optional string to print to console (not to NR).
 * @returns {function} - use this to handle Promise.catch.
 */

var nrAwareRejectionHandler = function nrAwareRejectionHandler() {
  var optMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function (err) {
    logger.error("[Compare-Cards-Bar] ".concat(optMessage), err);

    if (typeof newrelic !== 'undefined') {
      newrelic.noticeError(err); // eslint-disable-line
    }

    if (process.env.NODE_ENV === 'development') {
      console.error(err); // eslint-disable-line no-console
    }
  };
};

export default nrAwareRejectionHandler;
//# sourceMappingURL=nr-aware-error-handler.js.map